import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, NgZone, OnInit,QueryList,Renderer2, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { SharedService } from 'src/app/shared/services/shared.service';
import { environment } from 'src/environments/environment';
declare var $: any;
declare var dataLayer: any;
import videojs, { VideoJsPlayer } from 'video.js';
declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}
interface TimeSlot {
  id: string;
  label: string;
  time: string;
  active: boolean;
}
@Component({
  selector: 'app-the-great-ind-festival',
  templateUrl: './the-great-ind-festival.component.html',
  styleUrls: ['./the-great-ind-festival.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class TheGreatIndFestivalComponent implements OnInit, AfterViewInit {
  contactKeyArray = [];
  subscription;
  eventCarousal:any;
  eventCards: any;     // from API
  videoPlayers: VideoJsPlayer[] = [];
  selectedEventCard: any = null;
  selectedCarouselItem: any = null;
  allEvents:any;
  selectedDate: string = '';
selectedTimeSlot: string = '';
selectedModalCard: any = null;
selectedCardValues:any;
modalMediaItems = [];
// @ViewChild('videoPlayer', { static: false }) videoElement!: ElementRef;
@ViewChildren('videoPlayer') videoPlayersRefs!: QueryList<ElementRef>;
@ViewChild('responsiveSlider', {static:false})responsiveSlider!:ElementRef;
sliderInitialized=false; 



timeTabs: any[] = [];
eventCarousal1: any[] = [];
  baseUrl = environment.staticUrlForImgNew
  tabs:any[] = [
    { id: 12, label: '12 Sept', active: true, disabled: false },
    { id: 13, label: '13 Sept', active: false, disabled: false },
    { id: 14, label: '14 Sept', active: false, disabled: false },
    { id: null, label: 'Sept', active: false, disabled: true },
  ];

  constructor(private renderer: Renderer2,
    public _sharedService: SharedService,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
  ) { 
    this.getContactKeys();
  }

  ngOnInit(): void {
    this.getContactUsPageContent();    
  }
  

  getContactKeys() {
    return this.contactKeyArray = [
      "NMACC-NYC-EVENT-CAROUSEL",
      "NMACC-NYC-EVENT-CARDS"
    ];
  }
  async ngAfterViewInit() {
    try {
      await this.loadScript('assets/nycJs/jquery-3.3.1.min.js');

      if (!(window as any).jQuery) {
        throw new Error('jQuery not available globally');
      }

      await this.loadScript('assets/nycJs/popper.min.js');
      await this.loadScript('assets/nycJs/bootstrap.min.js');
      await this.loadScript('assets/nycJs/slick.min.js');
      await this.loadScript('assets/nycJs/main.js');
      // await this.addGoogleAnalyticsScript('G-R966NFY646');
      // await this.addGtmScript('GTM-5JX9G7S')

      console.log('All scripts loaded');
    } catch (error) {
      console.error('Script loading failed:', error);
    }
    // setTimeout(() => {

    //   this.getEventData();
    // }, 300);
    // $('#eventModal1').on('hidden.bs.modal', () => {

    // });
    this.initVideoPlayers();
    if(!this.sliderInitialized&&this.eventCarousal1.length>0) {
        setTimeout(()=>this.initSlickSlider(),100);
        } 

  }
  // addGtmScript(gtmId: string): void {
  //   // Create and append the GTM script tag dynamically
  //   const script = document.createElement('script');
  //   script.innerHTML = `
  //     (function(w,d,s,l,i){
  //       w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
  //       var f=d.getElementsByTagName(s)[0], j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
  //       j.async=true; j.src='https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  //       f.parentNode.insertBefore(j,f);
  //     })(window,document,'script','dataLayer','${gtmId}');
  //   `;
  //   document.head.appendChild(script);

  //    // Create the noscript tag with the GTM iframe
  //    const noscript = document.createElement('noscript');
  //    noscript.innerHTML = `
  //      <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
  //        height="0" width="0" style="display:none;visibility:hidden" 
  //        title="Google Tag Manager"></iframe>
  //    `;
  //    document.body.appendChild(noscript);

  // }

  // addGoogleAnalyticsScript(gaId: string): void {
  //   // Append the Google Analytics async script tag
  //   const script1 = document.createElement('script');
  //   script1.async = true;
  //   script1.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  //   document.head.appendChild(script1);

  //   // Append the second script for Google Analytics configuration
  //   const script2 = document.createElement('script');
  //   script2.innerHTML = `
  //     window.dataLayer = window.dataLayer || [];
  //     function gtag() { dataLayer.push(arguments); }
  //     gtag('js', new Date());
  //     gtag('config', '${gaId}');
  //   `;
  //   document.head.appendChild(script2);
  // }
  stripTags(html: string): string {
    return html ? html.replace(/<[^>]+>/g, '') : '';
  }
  
  private initSlickSlider():void{
     const $slider = $(this.responsiveSlider.nativeElement);
    
     if($slider.length===0) {
      console.warn('Slider element not found');
      return;
      }
    
     if($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
      }
    
     $slider.slick({
      dots:false,
      arrows:true,
      infinite:true,
      autoplay:true,
      autoplaySpeed:3000,
      slidesToShow:4,
      slidesToScroll:1,
      prevArrow:'<button type="button" class="slick-prev custom-prev"><i class="fas fa-chevron-left"></i></button>',
      nextArrow:'<button type="button" class="slick-next custom-next"><i class="fas fa-chevron-right"></i></button>',
      responsive:[
        {breakpoint:991,settings:{slidesToShow:2} },
        {breakpoint:767,settings:{slidesToShow:1.5,centerMode:false} }
       ]
      });
    
     this.sliderInitialized=true;
     console.log('Slick initialized');
     }

    trackByFn(index:number,item:any):any{
       return index;
       } 
      
  initVideoPlayers() {
    this.disposeVideoPlayers();

    this.videoPlayersRefs.forEach((videoElementRef, i) => {
      const media = this.modalMediaItems[i];
      if (media && media.type === 'video') {
        const player = videojs(videoElementRef.nativeElement, {
          autoplay: false,
          controls: true,
          preload: 'auto',
          fluid: true,
          sources: [
            {
              src: media.url,
              type: 'application/x-mpegURL',
            }
          ],
        });

        player.ready(() => {
          console.log(`Player ${i} ready`);
        });

        player.on('error', () => {
          console.error('Video.js player error:', player.error());
        });

        this.videoPlayers.push(player);
      }
    });
  }

  disposeVideoPlayers() {
    this.videoPlayers.forEach(player => player.dispose());
    this.videoPlayers = [];
  }

  ngOnDestroy() {
    this.disposeVideoPlayers();
  }

  loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = this.renderer.createElement('script');
      script.src = src;
      script.type = 'text/javascript';
      script.onload = () => {
        console.log(`${src} loaded`);
        resolve();
      };
      script.onerror = (err) => reject(err);
      this.renderer.appendChild(document.body, script);
    });
    
  }

  getContactUsPageContent() {
    this.subscription = this._sharedService.getCommonService().getlandingUrl(this.contactKeyArray).subscribe(
      (data: any) => {  
        this.eventCarousal = data[0]?.data;
        this.eventCards = data[1]?.data;
        this.getEventData();

       


      },
      (error) => {
        console.log("Try after some time..");;
      }
    )
  }
  formatLink(url: string): string {
  if (!url) return '#';
  return url.startsWith('http') ? url : `https://${url}`;
}

getWindowTarget(pref: string | string[]): string {
  // Parses either a JSON string or an array directly
  if (!pref) return '_self';
  const parsed = typeof pref === 'string' ? JSON.parse(pref) : pref;
  return parsed?.includes('_blank') ? '_blank' : '_self';
}

getDownloadLink(): string {
  const doc = this.eventCarousal?.SecondCTADocument?.document;
  return doc?.contentUrl ? doc.contentUrl : '#';
}

onDownloadClick(): void {
  const downloadUrl = this.getDownloadLink();
  if (downloadUrl && downloadUrl !== '#') {
    const a = document.createElement('a');
    a.href = this.baseUrl + downloadUrl;
    a.download = '';
    a.target = '_blank'; // Optional: open in new tab
    a.click();
  }
}

onBookNowClick(): void {
  const link = this.formatLink(this.eventCarousal?.FirstCTALink?.data);
  const target = this.getWindowTarget(this.eventCarousal?.FirstCTALinkWindowPreference?.data);

  if (link !== '#') {
    window.open(link, target);
  }
}

// getEventData() {
//   const apiResponse = this.eventCarousal?.cards || [];
//   this.allEvents = apiResponse;

//   const uniqueDates = [...new Set(
//     apiResponse.map(event => this.getFirstValue(event?.SelectDate?.data))
//   )].filter(Boolean);

//   this.tabs = uniqueDates.map((date, i) => ({
//     id: i,
//     label: date,
//     active: i === 0,
//     clickable: true  // ✅ mark as clickable
//   }));

//   // ✅ Add NonClickableDateText tab at the end
//   if (this.eventCarousal?.NonClickableDateText?.data) {
//     this.tabs.push({
//       id: this.tabs.length,
//       label: this.eventCarousal.NonClickableDateText.data,
//       active: false,
//       clickable: false  // ✅ mark as non-clickable
//     });
//   }

//   this.selectedDate = this.tabs[0]?.label || '';

//   // ✅ Extract unique time slots using Map to avoid duplicates
//   const timeSlotMap = new Map<string, TimeSlot>();

//   apiResponse.forEach(event => {
//     const label = this.getFirstValue(event?.SelectTimeOfDay?.data);
//     if (!label) return;

//     const time = this.getTimeForLabel(label);

//     if (!timeSlotMap.has(label)) {
//       timeSlotMap.set(label, {
//         id: label,
//         label,
//         time,
//         active: false
//       });
//     }
//   });

//   this.timeTabs = Array.from(timeSlotMap.values()).map((slot, i) => ({
//     ...slot,
//     active: false // default inactive
//   }));

//   // ✅ Auto-select default time tab for first date (Morning)
//   const defaultTimeTab = this.timeTabs.find(tab => tab.label.toLowerCase() === 'morning');
//   if (defaultTimeTab) {
//     this.onTimeTabClick(defaultTimeTab);
//   }

//   this.refreshSliderAfterDataUpdate();
// }
getCleanTimeLabel(data: string): string {
  try {
    const parsed = JSON.parse(data);
    return Array.isArray(parsed) ? parsed[0] : parsed;
  } catch {
    return '';
  }
}


getEventData() {
  const rawEvents = (this.eventCarousal?.cards || []).filter(card => card?.HideCard?.data === 'false');

  // ✅ Duplicate "Both" events into Morning and Evening
  const processedEvents = [];

  rawEvents.forEach(event => {
    const rawLabel = this.getFirstValue(event?.SelectTimeOfDay?.data);
    const label = rawLabel?.trim().toLowerCase();

    if (label === 'both') {
      const morningEvent = { ...event, SelectTimeOfDay: { data: JSON.stringify(['Morning']) },originalBoth: true };
      const eveningEvent = { ...event, SelectTimeOfDay: { data: JSON.stringify(['Evening']) }, originalBoth: true };
      processedEvents.push(morningEvent, eveningEvent);
    } else if (label === 'morning' || label === 'evening') {
      // processedEvents.push(event);
      processedEvents.push({ ...event, originalBoth: false });
    }
    // else: ignore other labels
  });

  this.allEvents = processedEvents;

  // ✅ Setup tabs (dates)
  const uniqueDates = [...new Set(
    processedEvents.map(event => this.getFirstValue(event?.SelectDate?.data))
  )].filter(Boolean);

  this.tabs = uniqueDates.map((date, i) => ({
    id: i,
    label: date,
    active: i === 0,
    clickable: true
  }));

  // ✅ Add non-clickable tab if exists
  if (this.eventCarousal?.NonClickableDateText?.data) {
    this.tabs.push({
      id: this.tabs.length,
      label: this.eventCarousal.NonClickableDateText.data,
      active: false,
      clickable: false
    });
  }

  this.selectedDate = this.tabs[0]?.label || '';

  // ✅ Extract only Morning and Evening for timeTabs
  const allowedLabels = ['morning', 'evening'];
  const timeSlotMap = new Map<string, TimeSlot>();

  processedEvents.forEach(event => {
    const label = this.getFirstValue(event?.SelectTimeOfDay?.data);
    if (!label) return;

    const normalized = label.trim().toLowerCase();
    if (!allowedLabels.includes(normalized)) return;

    if (!timeSlotMap.has(normalized)) {
      const displayLabel = normalized.charAt(0).toUpperCase() + normalized.slice(1);
      timeSlotMap.set(normalized, {
        id: normalized,
        label: displayLabel,
        time: this.getTimeForLabel(displayLabel),
        active: false
      });
    }
  });

  this.timeTabs = Array.from(timeSlotMap.values()).map(slot => ({
    ...slot,
    active: false
  }));

  // ✅ Auto-select Morning by default
  const defaultTimeTab = this.timeTabs.find(tab => tab.label.toLowerCase() === 'morning');
  if (defaultTimeTab) {
    this.onTimeTabClick(defaultTimeTab);
  }

  this.refreshSliderAfterDataUpdate(); // triggers applyCombinedFilter
}


onDateTabClick(selectedTab: any): void {
  // Ignore if not clickable
  if (!selectedTab.clickable) {
    return;
  }

  this.tabs.forEach(tab => tab.active = false);
  selectedTab.active = true;
  this.selectedDate = selectedTab.label;

  const selectedIndex = this.tabs.findIndex(tab => tab.id === selectedTab.id);
  let preferredLabel = selectedIndex === 0 ? 'morning' : (selectedIndex === 1 ? 'evening' : '');

  const preferredTimeTab = this.timeTabs.find(
    tab => tab.label.toLowerCase() === preferredLabel
  );

  if (preferredTimeTab) {
    this.onTimeTabClick(preferredTimeTab);
  }

  this.refreshSliderAfterDataUpdate();
}


onTimeTabClick(selectedTime: any): void {
  this.timeTabs.forEach(tab => tab.active = false);
  selectedTime.active = true;
  this.selectedTimeSlot = selectedTime.label;
  this.refreshSliderAfterDataUpdate();
}

applyCombinedFilter() {
  this.eventCarousal1 = this.allEvents.filter(event => {
    const date = this.getFirstValue(event?.SelectDate?.data);
    const time = this.getFirstValue(event?.SelectTimeOfDay?.data);

    return (
      date?.toLowerCase() === this.selectedDate?.toLowerCase() &&
      time?.toLowerCase() === this.selectedTimeSlot?.toLowerCase()
    );
  });
}

getFirstValue(data: string | undefined): string {
  try {
    const parsed = JSON.parse(data || '');
    return Array.isArray(parsed) && parsed.length > 0 ? parsed[0] : '';
  } catch {
    return data || '';
  }
}

getTimeForLabel(label: string): string {
  if (!label) return '';
  const timingMap = {
    morning: this.eventCarousal?.MorningShowTiming?.data,
    evening: this.eventCarousal?.EveningShowTiming?.data
  };
  return timingMap[label.toLowerCase()] || '';
}


  onDataLayer(evt: any) {
    const fullData = this.stripTags(evt?.CardHeader?.data) || '';
    const [val1, val2] = fullData.split(/\s+[\u002D\u2011\u2013\u2014]\s+/).map(str => str.trim());
    dataLayer.push({
      event: 'card_frame_book_now_clicks',
      artist_name: val1 ? val1 : '',
      events_name: val2 ? val2 : '',
      event_date: this.getFirstValue(evt?.SelectDate?.data),
      event_time: this.getCleanTimeLabel(evt?.SelectTimeOfDay?.data),
      event_venue: evt?.Venue?.data,
      page_title: 'NMACC_IndiaWeekend',
      User_ID: '',
      page_url: 'https://nmaac.com/IndiaWeekend'
    })
  }



getTarget(cta: any): string {  
  
    
  try {
    const parsed = JSON.parse(cta?.CardCTALinkWindowPreference?.data || '[]');
    return parsed[0] || '_self'; // fallback to '_self' if array empty
  } catch {
    return '_self';
  }
}


refreshSliderAfterDataUpdate():void{
  const $slider = $(this.responsiveSlider.nativeElement);
  
  // Destroy slick if already initialized
  if($slider.hasClass('slick-initialized')) {
   $slider.slick('unslick');
   }
  
  // Apply the data filter
  this.applyCombinedFilter();
  
  // Re-initialize after DOM updates
  setTimeout(()=>{
   this.initSlickSlider();
   },0); 
  }
  onSliderClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    const sliderItem = target.closest('.slider-item');
    if (!sliderItem) return;

    const sequenceValue = sliderItem.getAttribute('data-id');
    const artistHeader = sliderItem.getAttribute('data-header') || '';
    const eventVenue = sliderItem.getAttribute('data-venue') || '';
    const eventTime = sliderItem.getAttribute('data-time') || '';
    const eventDate = sliderItem.getAttribute('data-date') || '';
    let artistName = '';
     let eventsName = '';

  const parts = artistHeader.split(/\s+[\u002D\u2011\u2013\u2014]\s+/);
  if (parts.length === 2) {
    [artistName, eventsName] = parts.map(str => str.trim());
  } else {
    artistName = artistHeader.trim();
  }
    dataLayer.push({
      event: 'card_frame_clicks',
    artist_name: artistName,
    events_name: eventsName,
    event_date: eventDate,
    event_time: eventTime,
    event_venue: eventVenue,
    page_title: 'NMACC_IndiaWeekend',
    User_ID: '', // Add dynamic user ID if available
    page_url: 'https://nmaac.com/IndiaWeekend'
    })
    if (!sequenceValue) return;
  
    const cardIndex = this.eventCarousal1.findIndex(
      card => card?.Sequence?.data?.toString() === sequenceValue
    );
    // Now get the full card object if match was found
    if (cardIndex !== -1) {
      const cardVal = this.eventCarousal1[cardIndex];
    if (cardVal) {
      this.openEventModal(cardVal,sequenceValue);
    }
  }
  
  
  }

  
  
  
  thumbnailImages:any;
  dayOf:any;
openEventModal(cardVal: any, sequencePara:any) {
  this.dayOf = this.getFirstValue(cardVal.SelectTimeOfDay.data);
  const slider = $('.pop-slider');
     if (slider.hasClass('slick-initialized')) {
       slider.slick('unslick');
      }
  $('#eventModal2').modal('show');
  this.selectedCardValues = cardVal;
  // let sequenceValue = cardVal?.Sequence?.data
  this.thumbnailImages = this.eventCards.cards.filter(evt => evt.Sequence.data === sequencePara);

  // const cards = this.eventCards['cards'] || [];
  let cards = this.eventCards.cards.filter(evt => evt.Sequence.data === sequencePara);
  const modalMediaItems = cards.flatMap(card => {    
    const imageVideoItems = card.ImageVideo || [];
  
    return imageVideoItems.map(item => {
      
      const videoUrl = item?.VideoLink?.data?.trim();
      const imageUrl = this.baseUrl + item?.SelectImage?.document?.contentUrl?.trim();
      const imageAlt = item?.ImageAltText?.data?.trim() || '';

      if (videoUrl) {
        return {
          type: 'video',
          url: videoUrl
        };
      } else if (imageUrl) {
        return {
          type: 'image',
          url: imageUrl,
          alt: imageAlt
        };
      }
      return null;
    }).filter(Boolean); // removes nulls
  });
  const uniqueMediaItems = Array.from(new Map(
    modalMediaItems.map(item => [item.url, item])
  ).values());

  this.modalMediaItems = uniqueMediaItems;
  this.initVideoPlayers()
}


closeEventModal(): void {
   this.ngZone.run(() => {     
     const slider = $('.pop-slider');
     if (slider.hasClass('slick-initialized')) {
       slider.slick('unslick');
      }
  
    });
  } 
   

// getEventData() {
//   const apiResponse = this.eventCarousal?.cards || [];

//   this.allEvents = apiResponse;

  
//   const uniqueDates = [...new Set(apiResponse.map(event => event?.Date?.data?.trim()))];
//   this.tabs = uniqueDates.map((date, i) => ({
//     id: i,
//     label: date,
//     active: i === 0
//   }));
//   this.selectedDate = this.tabs[0]?.label || '';

  
//   const uniqueTimeSlots = [...new Map(apiResponse.map(event => [
//     event?.TimeOfDay?.data?.trim() || '',
//     {
//       id: event?.TimeOfDay?.data?.trim() || '',
//       label: event?.TimeOfDay?.data?.trim() || '',
//       time: event?.TimeOfDayTiming?.data?.trim() || '',
//       active: false
//     } as TimeSlot
//   ])).values()] as TimeSlot[];

  
//   this.timeTabs = uniqueTimeSlots.map((slot, i) => ({
//     ...slot,
//     active: i === 0
//   }));
//   this.selectedTimeSlot = this.timeTabs[0]?.label || '';
  
//   this.refreshSliderAfterDataUpdate();
// }

  
// isModalVisible = false;

// openEventModal(cardVal: any) {
//   this.ngZone.run(() => {
    
//     this.isModalVisible = false;
//     this.modalMediaItems = [];
//     this.selectedCardValues = null;


//     setTimeout(() => {
//       const sequenceValue = cardVal?.Sequence?.data;
//       const filteredCards = this.eventCards.cards.filter(
//         card => card.Sequence?.data === sequenceValue
//       );

//       let media: any[] = [];

//       for (let card of filteredCards) {
//         const imageVideoItems = card.ImageVideo || [];
//         for (let item of imageVideoItems) {
//           const videoUrl = item?.VideoLink?.data?.trim();
//           const imageUrlRaw = item?.SelectImage?.document?.contentUrl?.trim();
//           const imageUrl = imageUrlRaw ? this.baseUrl + imageUrlRaw : null;
//           const imageAlt = item?.ImageAltText?.data?.trim() || '';

//           if (videoUrl) {
//             media.push({ type: 'video', url: videoUrl });
//           } else if (imageUrl) {
//             media.push({ type: 'image', url: imageUrl, alt: imageAlt });
//           }
//         }
//       }

//       const unique = Array.from(new Map(media.map(m => [m.url, m])).values());

//       this.modalMediaItems = unique;
//       this.selectedCardValues = cardVal;

      
//       this.isModalVisible = true;


//       setTimeout(() => {
//         $('#eventModal2').modal('show');
//         this.initVideoPlayers?.();
//       }, 50);
//     }, 50);
//   });
// }


}
